import { PLACEHOLDER_EVENT_DATE } from '#shared/constants';
import { getEventDates } from '#shared/eventUtils';
import type { EventInput, EventRecord } from '#shared/types';

export type EventFieldValues = {
  title: string;
  description: string;
  dates: string[];
  highlight: boolean;
};

export const emptyEventFieldValues = (): EventFieldValues => ({
  title: '',
  description: '',
  dates: [''],
  highlight: false,
});

export const eventToFieldValues = (event: EventRecord): EventFieldValues => {
  const dates = getEventDates(event);
  return {
    title: event.title ?? '',
    description: event.description ?? '',
    dates: dates.length > 0 ? dates : [''],
    highlight: Boolean(event.highlight),
  };
};

export const toEventInput = (
  fields: EventFieldValues,
  imageKey?: string,
): EventInput => {
  const dates = fields.dates
    .map((value) => value.trim())
    .filter((value) => value.length > 0 && value !== PLACEHOLDER_EVENT_DATE)
    .sort((a, b) => a.localeCompare(b));

  return {
    title: fields.title.trim() || undefined,
    description: fields.description.trim(),
    dates,
    date: dates[0] ?? PLACEHOLDER_EVENT_DATE,
    highlight: fields.highlight,
    imageKey,
  };
};
